/* eslint-disable no-unused-vars */
import { Info } from '@mui/icons-material'
import { Box, Button, CircularProgress, Divider, Typography } from '@mui/material'
import { Dialog } from '~/components'

export type DataReviewModalProps = {
  isVisible: boolean
  toggleModal: () => void
  loading: boolean
  onSubmit: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>
}

export const DataReviewModal: React.FC<DataReviewModalProps> = (props) => {
  const { isVisible, toggleModal, onSubmit, loading } = props

  return (
    <Dialog
      isVisible={isVisible}
      title='Revisão dos dados'
      onClose={toggleModal}
      titleIcon={<Info fontSize='large' color='primary' />}
    >
      <Box sx={{ flexDirection: 'column', display: 'flex', gap: 3 }}>
        <Divider />
        <Typography>Ao seguir, você estará gerando o termo de gestão para assinatura do cliente. Se certifique de que todos os dados e documentos foram preenchidos corretamente.</Typography>
        <Typography>Deseja seguir para o passo de assinatura?</Typography>

        <Divider />

        <Box sx={{ flexDirection: 'row', display: 'flex', gap: 3, justifyContent: 'end' }}>
          <Button
            color='secondary'
            disabled={loading}
            onClick={toggleModal}
          >
            Voltar e revisar
          </Button>

          <Button
            color='primary'
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={24} color='inherit' /> : null}
          >
            Seguir para assinatura
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
